import { SurveyType } from '../common/constants';

export function groupSurveyResults(survey) {
    const questions = Object.fromEntries((survey.content || []).map(question => [question.id, { ...question, answers: [] }]));
    for (const participation of survey.users_survey || []) {
        const user = participation.user;
        if (!user) continue;
        for (const question of participation.content || []) {
            const target = questions[question.id];
            if (!target) continue;
            let answer;
            switch (question.type) {
                case SurveyType.Open: {
                    const value = question.value ?? question.answer;
                    if (typeof value !== 'string' || !value.trim()) continue;
                    answer = { answerValue: value };
                    break;
                }
                case SurveyType.SingleChoice:
                    answer = { id: question.answerId, value: question.answer?.value, answerValue: question.answer?.answerValue }; break;
                case SurveyType.MultipleChoice:
                    answer = { answers: question.answers || [] }; break;
                case SurveyType.Numeric:
                    answer = { id: question.answerId, value: question.answer }; break;
                default: continue;
            }
            target.answers.push({ ...answer, userId: user.id, name: user.name, surname: user.surname, picture: user.picture });
        }
    }
    return Object.values(questions).reduce((groups, question) => {
        (groups[question.group] ||= []).push(question);
        return groups;
    }, {});
}
